var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScreeningEmpty2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6577_41586)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.926758 15.1333H54.2014",
    stroke: "#B2BDD1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2014 20.4612V0.926758H0.926758V41.771H15.1337",
    stroke: "#B2BDD1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.02934 9.80478C9.00989 9.80478 9.80478 9.00989 9.80478 8.02934C9.80478 7.0488 9.00989 6.25391 8.02934 6.25391C7.0488 6.25391 6.25391 7.0488 6.25391 8.02934C6.25391 9.00989 7.0488 9.80478 8.02934 9.80478Z",
    fill: "#B2BDD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1338 9.80478C16.1144 9.80478 16.9093 9.00989 16.9093 8.02934C16.9093 7.0488 16.1144 6.25391 15.1338 6.25391C14.1533 6.25391 13.3584 7.0488 13.3584 8.02934C13.3584 9.00989 14.1533 9.80478 15.1338 9.80478Z",
    fill: "#B2BDD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2364 9.80478C23.2169 9.80478 24.0118 9.00989 24.0118 8.02934C24.0118 7.0488 23.2169 6.25391 22.2364 6.25391C21.2558 6.25391 20.4609 7.0488 20.4609 8.02934C20.4609 9.00989 21.2558 9.80478 22.2364 9.80478Z",
    fill: "#B2BDD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9843 38.1561C32.0893 38.1561 33.7958 36.4497 33.7958 34.3447C33.7958 32.2396 32.0893 30.5332 29.9843 30.5332C27.8793 30.5332 26.1729 32.2396 26.1729 34.3447C26.1729 36.4497 27.8793 38.1561 29.9843 38.1561Z",
    stroke: "#B2BDD1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8457 42.6558L27.3148 45.4515",
    stroke: "#B2BDD1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3457 41.2241C25.1008 41.8449 25.9382 42.3301 26.845 42.6567",
    stroke: "#B2BDD1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6895 42.2143L24.3451 41.2241",
    stroke: "#B2BDD1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0801 40.0625C20.5375 40.8547 21.0877 41.5785 21.6899 42.2143",
    stroke: "#B2BDD1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0215 37.5923C19.2716 38.4308 19.6226 39.2693 20.08 40.0615",
    stroke: "#B2BDD1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2069 35.7876L19.0215 37.592",
    stroke: "#B2BDD1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2163 32.9062C21.0461 33.8559 21.0472 34.823 21.2071 35.7877",
    stroke: "#B2BDD1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0303 31.1021L21.2157 32.9064",
    stroke: "#B2BDD1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6952 26.4683C20.4305 27.7851 19.5248 29.3937 19.0303 31.1032",
    stroke: "#B2BDD1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3567 27.4689L21.6953 26.4683",
    stroke: "#B2BDD1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5376 26.6421C25.1079 26.8899 24.7095 27.1644 24.3574 27.4702",
    stroke: "#B2BDD1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8437 26.0337C26.4036 26.1854 25.9658 26.3939 25.5361 26.6417",
    stroke: "#B2BDD1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3082 23.2275L26.8438 26.0337",
    stroke: "#B2BDD1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6536 23.237C30.9257 22.8108 29.0807 22.7911 27.3076 23.2277",
    stroke: "#B2BDD1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1233 26.0326L32.6543 23.2368",
    stroke: "#B2BDD1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6223 27.4653C34.8684 26.8446 34.0299 26.3593 33.123 26.0327",
    stroke: "#B2BDD1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2789 26.4741L35.6221 27.4655",
    stroke: "#B2BDD1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8881 28.6269C39.4307 27.8348 38.8806 27.1109 38.2783 26.4751",
    stroke: "#B2BDD1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9472 31.0961C40.6982 30.2576 40.3461 29.4191 39.8887 28.627",
    stroke: "#B2BDD1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7607 32.9006L40.9473 31.0962",
    stroke: "#B2BDD1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.752 35.7819C38.9222 34.8322 38.921 33.8651 38.7612 32.9004",
    stroke: "#B2BDD1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9385 37.5866L38.752 35.7822",
    stroke: "#B2BDD1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2734 42.2213C39.5381 40.9045 40.4438 39.2958 40.9383 37.5864",
    stroke: "#B2BDD1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6123 41.2197L38.2737 42.2215",
    stroke: "#B2BDD1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4316 42.0478C34.8613 41.8 35.2597 41.5255 35.6118 41.2197",
    stroke: "#B2BDD1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.124 42.6554C33.5641 42.5037 34.0019 42.2952 34.4316 42.0474",
    stroke: "#B2BDD1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6611 45.4608L33.1244 42.6558",
    stroke: "#B2BDD1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3154 45.4512C29.0434 45.8774 30.8883 45.8971 32.6614 45.4604",
    stroke: "#B2BDD1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2064 45.8523L44.5021 55.9084C44.3412 56.5443 43.9312 57.1036 43.3255 57.4534C42.1152 58.1518 40.5529 57.7337 39.8545 56.5234C39.5048 55.9177 39.4295 55.2286 39.6078 54.5974L42.2947 44.5366",
    stroke: "#B2BDD1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8405 27.1178C39.679 26.1055 40.7075 25.2184 41.9177 24.5189C47.3865 21.3618 54.3817 23.2357 57.5388 28.7044C60.6959 34.1732 58.822 41.1684 53.3533 44.3255C48.423 47.1722 42.2524 45.9364 38.7676 41.6548",
    stroke: "#B2BDD1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6577_41586"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 58.7179,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreeningEmpty2);
export default __webpack_public_path__ + "static/media/screening_empty2.805c35f7288bfb9ca64600f7db5beb68.svg";
export { ForwardRef as ReactComponent };